module.exports = __webpack_public_path__ + "static/media/success.6916282b.svg";